import React from 'react';
import PlaceholderLayout from './PlaceholderLayout';
import { Button } from '@primer/react';

const AccessDeniedLayout: React.FC<{
    message: string;
    onSignOut: () => void;
}> = ({ message, onSignOut }) => (
    <PlaceholderLayout>
        <div className="w-full flex flex-col justify-center items-center">
            <span className="whitespace-pre-line text-center">{message}</span>
            <Button variant="default" className='mt-10' onClick={onSignOut}>
                Выйти
            </Button>
        </div>
    </PlaceholderLayout>
);

export default AccessDeniedLayout